var React = require('react');

function IconOracleColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.15 30C6.6975 30 0 23.2099 0 15C0 6.63119 6.85725 0 15.15 0H32.85C41.3025 0 48 6.7901 48 15C48 23.3688 41.1427 30 32.85 30H15.15ZM32.532 24.6312C37.9545 24.6312 42.4192 20.2106 42.4192 14.8418C42.4192 9.47302 37.9545 5.05247 32.532 5.05247H15.6277C10.2052 5.05247 5.7405 9.47302 5.7405 14.8418C5.7405 20.2106 10.206 24.6312 15.6277 24.6312H32.532Z","fill":"#E30613"}));
}

IconOracleColor.defaultProps = {"width":"48","height":"30","viewBox":"0 0 48 30","fill":"none"};

module.exports = IconOracleColor;

IconOracleColor.default = IconOracleColor;
